export default "__VITE_ASSET__fXDta$_s__"